import * as log from 'loglevel';

/* eslint-disable no-underscore-dangle */
import dataLayerMiddleware from '@dc/data-layer';

function trackFunction(data) {
  if (typeof window === 'undefined') {
    return;
  }
  if (typeof window._satellite.track !== 'function') {
    log.warn('[DataLayer] window._satellite.track is not a function', data);
  }
  try {
    window._satellite.track(data);
  } catch (error) {
    log.warn('[DataLayer] window._satellite.track is not working', error);
  }
}

if (typeof window !== 'undefined' && !window.digitalData) {
  window.digitalData = {};
}
const digitalData = typeof window !== 'undefined' ? window.digitalData : {};

export default function getDataLayerMiddleware() {
  return dataLayerMiddleware(
    digitalData,
    trackFunction
  );
}

export function getDigitalData() {
  return digitalData;
}
